<template>
    
    <v-dialog v-model="dialog" width="800">

      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on">
           <v-icon>mdi-chart-bar</v-icon>
        </v-btn>
      </template>

      <v-card>

        <v-card-title>
          Time Chart
        </v-card-title>


            <div style="height:400px">

            <v-chart ref="chart" class="chart" :option="chartOptions" autoresize/>
            </div>


        <v-divider></v-divider>

        <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn-toggle  @change="syncChart" v-model="timeOptions">
                <v-btn>
                    <v-icon>D</v-icon>
                </v-btn>
                <v-btn>
                    <v-icon>M</v-icon>
                </v-btn>
                <v-btn>
                    <v-icon>Y</v-icon>
                </v-btn>
            </v-btn-toggle>

            <v-spacer></v-spacer>

            <v-btn-toggle @change="syncChart" v-model="valueOptions" multiple>
                <v-btn>
                    <span class="font-weight-black">>0.5</span>
                </v-btn>
                <v-btn>
                    <v-icon>mdi-percent</v-icon>
                </v-btn>

            </v-btn-toggle>


            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog = false">
                Close
            </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

</template>


<script>

export default {

    props : {
        info : {
            default : null,
            type : Object
        },
        imageSize : {
            default : 1,
            type : Number
        }
    },

    data: () => ({

        dialog : false,

        chartOptions : {},

        percent : false,

        values : [],
        values05 : [],
        dates: [],

        timeOptions: [],

        timeGapsOption : 0,
        monthOption : 1,
        yearOption : 2,

        valueOptions : [0], // by default, binaryOption is on

        binaryOption : 0,
        percentOption : 1,


    }),

    mounted() {

        this.chartOptions = {
                xAxis: {
                    type: 'category',
                    data: this.dates
                },

                yAxis: {
                    type: 'value'
                },
                
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'cross'
                }},

                series: [{
                    data: this.values,
                    type: 'bar',
                    itemStyle: {color: this.$vuetify.theme.currentTheme.primary},
                }]
        }

    },

    methods: {

        updateChartData(dates, values) 
        {

            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.chart.setOption({
                        
                        series:{ 
                            data: values,
                        },
    
                        xAxis : {
                            data: dates
                        }
                    });
                })
            })
        },

        getChartData()
        {
            // clone original data
            let _data = JSON.parse(JSON.stringify(this.info.individual_stats)); 

            let _values = []
            let _dates = []

            // if percent option is enabled, convert to percent
            if(this.valueOptions.includes(this.percentOption))
                _data = _data.map( x => {
                    x.sum = x.sum / this.imageSize * 100;
                    x.sum_treshold = x.sum_treshold / this.imageSize * 100;
                    return x;
                })


            // if yearOption, aggregate by year
            if(this.timeOptions == this.yearOption)
                _data = this.aggregateByDate(_data, true);

            // if monthOption, aggregate by month
            else if(this.timeOptions == this.monthOption)
                _data = this.aggregateByDate(_data);

            // if binary option is enabeld, use sum_treshold (sum of values using a treshold)
            if(this.valueOptions.includes(this.binaryOption))
                _values = _data.map(x => x.sum_treshold);

            // if probability option is enabled, use normal sum
            else
                _values = _data.map(x => x.sum);


            _dates = _data.map((x) => x.date);

            return [_dates, _values];

        },

        syncChart()
        {
            let _data = this.getChartData();
            this.updateChartData(..._data);
        },

        aggregateByDate(data, year = false)
        {
            let sub = 7;

            if(year)
                sub = 4;

            let total = [];

            data.forEach(item => {
                
                item.date = item.date.substring(0, sub);

                let aggregated = total.find(x => x.date == item.date);

                if(!aggregated)
                {
                    item['count'] = 1;
                    total.push(item);
                }
                    

                else {
                    aggregated.sum += item.sum;
                    aggregated.sum_treshold += item.sum_treshold;
                    aggregated.count += 1;
                }
            });

            total.map(x => {
                x.sum = x.sum/x.count;
                x.sum_treshold = x.sum_treshold/x.count;
                return x;
            })

            return total;

          
        }

    },


    watch: {
        dialog : function() {

            if(this.dialog == false)
                return;

            if(!this.info)
                return;

            this.syncChart();
        },

    }

};
</script>
